module.exports = __webpack_public_path__ + "static/media/400409_02.2c2b6572.png";